module.exports = __webpack_public_path__ + "media/images/emblems/Speicherar-5ccc91788a2f0c5c61614ad35e620026.png";